import * as React from 'react';
import { AssetsSidebar, type AssetsScope, type MediaTypeFilter } from './AssetsSidebar';
import { AssetsList } from './AssetsList';

const SCOPE_LABELS: Record<AssetsScope, string> = {
  my: '我的',
  shared: '共享',
};

const TYPE_LABELS: Record<MediaTypeFilter, string> = {
  all: '全部',
  document: '文档',
  image: '图片',
  audio: '音频',
  video: '视频',
};

export function AssetsLayout() {
  const [scope, setScope] = React.useState<AssetsScope>('my');
  const [mediaType, setMediaType] = React.useState<MediaTypeFilter>('all');
  const [selectedCategoryId, setSelectedCategoryId] = React.useState<string | null>(null);
  const [selectedCategoryName, setSelectedCategoryName] = React.useState<string | null>(null);

  return (
    <div className="flex h-full w-full border-t border-divider">
      <AssetsSidebar
        scope={scope}
        mediaType={mediaType}
        selectedCategoryId={selectedCategoryId}
        onScopeChange={setScope}
        onMediaTypeChange={setMediaType}
        onCategorySelect={(id, name) => {
          setSelectedCategoryId(id);
          setSelectedCategoryName(name ?? null);
        }}
      />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <AssetsList
          scope={scope}
          mediaType={mediaType}
          selectedCategoryId={selectedCategoryId}
          scopeLabel={SCOPE_LABELS[scope]}
          typeLabel={TYPE_LABELS[mediaType]}
          selectedCategoryName={selectedCategoryName}
        />
      </div>
    </div>
  );
}
